import { resolveDotNotationPath } from "../../../_core/utils/object.utils";
import { Action, Condition, ConditionRelation } from "./collection.model";

export class CollectionUtils {

	public static isConditionValid(condition: Condition, element: any) {
		switch(condition?.relation) {
			case ConditionRelation.EQ:
				return resolveDotNotationPath(condition.path, element) === condition.value;

			case ConditionRelation.NEQ:
				return resolveDotNotationPath(condition.path, element) !== condition.value;

			case ConditionRelation.GT:
				return resolveDotNotationPath(condition.path, element) > condition.value;

			case ConditionRelation.GTE:
				return resolveDotNotationPath(condition.path, element) >= condition.value;

			case ConditionRelation.LT:
				return resolveDotNotationPath(condition.path, element) < condition.value;

			case ConditionRelation.LTE:
				return resolveDotNotationPath(condition.path, element) <= condition.value;
		}

		return false;
	}

}
